/**
 * =============================================================================
 * SPEQ55 RFP Pro - Pricing Management API Client
 * =============================================================================
 *
 * API client functions for managing API pricing configuration.
 *
 * @module api/pricing
 * @author SPEQ55
 */

import api from './client.js';

/**
 * Get all active pricing configurations
 */
export async function getActivePricing() {
  const response = await api.get('/pricing');
  return response.data;
}

/**
 * Get pricing history for a model
 */
export async function getPricingHistory(serviceName, modelName) {
  const response = await api.get(`/pricing/history/${serviceName}/${modelName}`);
  return response.data;
}

/**
 * Create new pricing configuration
 */
export async function createPricing(data) {
  const response = await api.post('/pricing', data);
  return response.data;
}

/**
 * Update pricing configuration
 */
export async function updatePricing(serviceName, modelName, data) {
  const response = await api.put(`/pricing/${serviceName}/${modelName}`, data);
  return response.data;
}

/**
 * Get pricing audit history
 */
export async function getPricingAuditHistory(limit = 50) {
  const response = await api.get(`/pricing/audit?limit=${limit}`);
  return response.data;
}

export default {
  getActivePricing,
  getPricingHistory,
  createPricing,
  updatePricing,
  getPricingAuditHistory,
};
